import {
	colors,
	designTokens,
	RiFilePaperLine,
	RiPencilLine,
	RiSquareFill
} from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Chip } from "@itandi/itandi-bb-ui/Chip";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Td } from "@itandi/itandi-bb-ui/Td";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import { DealTypeChip } from "~/components/common/parts/chip/DealTypeChip";
import type { DealIndexVendor } from "~/models/Deal";
import { formatPropertyName } from "~/models/Deal";
import { statusColor } from "~/models/Status";
import { PATH as VENDOR_DEAL_PATH } from "~/pages/vendors/deals/[id]";
import { truncate } from "~/utils/StringUtil";

type Props = {
	deal: DealIndexVendor;
	statusNames: Record<string, string>;
};

export function DealTableSPRow({ deal, statusNames }: Props) {
	const unread = deal.unreadMessageCount > 0 || deal.displayUnread;
	const unreadChipLabel =
		deal.unreadMessageCount > 0 ? `未読${deal.unreadMessageCount}` : "未読";
	return (
		<Tr>
			<Td textAlign="Left" verticalAlign="Top">
				<Box marginY={2}>
					<Chip
						Icon={RiSquareFill}
						iconColor={statusColor[deal.statusId]}
						label={statusNames[deal.statusId]}
					/>
				</Box>
				{unread ? (
					<Box marginY={2}>
						<Chip
							background={colors["semantic-negative"]}
							borderColor={null}
							label={unreadChipLabel}
							textColor={colors["itandi-white"]}
						/>
					</Box>
				) : null}
				{deal.hasTemporaryDealCancel ? (
					<Box marginY={2}>
						<Chip
							background={colors["semantic-negative"]}
							borderColor={null}
							Icon={RiFilePaperLine}
							iconColor={colors["itandi-white"]}
							label="取下申請あり"
							textColor={colors["itandi-white"]}
						/>
					</Box>
				) : null}
				{deal.hasRequestEstimation ? (
					<Box marginY={2}>
						<Chip
							background={colors["expressive-blue"]}
							borderColor={null}
							Icon={RiFilePaperLine}
							iconColor={colors["itandi-white"]}
							label="見積申請中"
							textColor={colors["itandi-white"]}
						/>
					</Box>
				) : null}
				{deal.hasDraftEstimation ? (
					<Box marginY={2}>
						<Chip
							background={colors["expressive-yellow-dark"]}
							borderColor={null}
							Icon={RiPencilLine}
							iconColor={colors["itandi-white"]}
							label="見積編集中"
							textColor={colors["itandi-white"]}
						/>
					</Box>
				) : null}
				{deal.hasRequestEstimationByCompany ? (
					<Box marginY={2}>
						<Chip
							background={colors["expressive-aqua-dark"]}
							borderColor={null}
							Icon={RiFilePaperLine}
							iconColor={colors["itandi-white"]}
							label="見積申請あり"
							textColor={colors["itandi-white"]}
						/>
					</Box>
				) : null}
			</Td>
			<Td textAlign="Left" verticalAlign="Top">
				<Box>
					<Flex gap={2}>
						<DealTypeChip
							dealSubtype={deal.dealSubtype}
							dealType={deal.dealType}
						/>
					</Flex>
				</Box>
				<Box>
					<TextLink
						color="link"
						href={VENDOR_DEAL_PATH(deal.id)}
						target="_blank"
						weight="bold"
					>
						{formatPropertyName(deal, 30)}
					</TextLink>
					<Flex direction="column" gap={designTokens["spacing/xxxs"]}>
						<Label color="subtle">{truncate(deal.address, 35)}</Label>
						{deal.tenantName ? (
							<Label color="subtle">
								{`${truncate(deal.tenantName, 15)} 様`}
							</Label>
						) : null}
					</Flex>
				</Box>
			</Td>
		</Tr>
	);
}
